import React from "react";

const Colapse = () => {
  return (
    <svg
      width="6"
      height="2"
      viewBox="0 0 16 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.62793 2.64746H14.3721C14.8994 2.64746 15.3477 2.19922 15.3477 1.66309C15.3477 1.12695 14.8994 0.6875 14.3721 0.6875H1.62793C1.11816 0.6875 0.652344 1.12695 0.652344 1.66309C0.652344 2.19922 1.11816 2.64746 1.62793 2.64746Z"
        fill="#797979"
      />
    </svg>
  );
};

export default Colapse;
